import { useEffect } from 'react';

const CUSTOM_PAGE_TITLES = {
  login: 'Login',
  quote: 'Get a Quote',
  plan: 'Plan Premiums',
  review: 'Review & Summary',
  signature: 'Signature',
  challenge: 'Challenge',
  knockout: 'Knockout',
  timeout: 'Application Timeout',
  completed: 'Application Completed',
  inactivesession: 'Inactive Session',
  authError: 'Authentication Error',
  ssodone: 'Authentication in progress',
};

/* using custom hook for achieving dynamic titles in place of react-helmet */
function useDocumentTitle(docTitle, pageId = '', breadcrumbTitle = '') {
  useEffect(() => {
    const defaultTitle = `${docTitle}`;
    const customPageName = CUSTOM_PAGE_TITLES[pageId];

    if (pageId && customPageName) {
      // Get a Quote | Navy Mutual
      document.title = `${customPageName} | ${defaultTitle}`;
    } else if (breadcrumbTitle) {
      // Beneficiary Information | Navy Mutual
      document.title = `${breadcrumbTitle} | ${defaultTitle}`;
    } else {
      // Navy Mutual
      document.title = defaultTitle;
    }
  }, [docTitle, breadcrumbTitle]);

  useEffect(() => {
    return () => {
      if (!pageId) {
        document.title = docTitle;
      }
    };
  }, []);
}

export default useDocumentTitle;
